import { render } from "./CommingSoon.vue?vue&type=template&id=3d07a748"
import script from "./CommingSoon.vue?vue&type=script&lang=js"
export * from "./CommingSoon.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__